export default class ScrubbingRangeSlider {
  #ctrl: any;
  #value: any = null;

  constructor(
    controlWrapper: any,
    parameterMeta: any,
    finishedInteractionCallback: Function
  ) {
    this.#init(controlWrapper, parameterMeta, finishedInteractionCallback);
  }

  #init(
    controlWrapper: any,
    parameterMeta: any,
    finishedInteractionCallback: Function
  ) {
    const that = this;
    const labelHTML = `<label>${parameterMeta.label} (<span class="selectionmin">${parameterMeta.defaultvalue[0]}</span>-<span class="selectionmax">${parameterMeta.defaultvalue[1]}</span>):</label>`;
    $(controlWrapper).append(labelHTML);
    $(controlWrapper).append(
      `<div class="control rangeslider ${parameterMeta.name}"></div>`
    );
    const div = $(controlWrapper).find(".control");
    this.#value = parameterMeta.defaultvalue;
    this.#ctrl = div.slider({
      range: true,
      min: parameterMeta.control.extent[0],
      max: parameterMeta.control.extent[1],
      step: parameterMeta.control.stepsize,
      values: parameterMeta.defaultvalue,
      slide: function (event, ui) {
        const label = $(event.target).siblings("label");
        that.#value = ui.values as any;
        label.find(".selectionmin").text(that.#value[0]);
        label.find(".selectionmax").text(that.#value[1]);
      },
      stop: function (event, ui) {
        that.#value = ui.values as any;
        finishedInteractionCallback();
      },
    });
    div.data("public", this);
  }

  getValue() {
    return this.#value;
  }
}
